// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b6676ae","455":"b4d124b6","977":"0d6640a0"}[chunkId] + ".chunk.js";
};